import { onePageCheckoutCustom } from "@dana/Store/Pages/OnePageCheckoutExt/OnePageCheckoutReducerExt";
import { ApiHandler, createHandlerChainRunner} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<{ shipComplete: boolean },DispatchProp<onePageCheckoutCustom>>;

export const DispatchSetShipComplete: HandlerType = props => {
           props.dispatch({
            type: "Pages/OnePageCheckout/SetShipComplete",
            shipComplete: props.parameter.shipComplete,
        } as any);
};

export const chain = [DispatchSetShipComplete];
const setShipComplete = createHandlerChainRunner(chain, "SetShipComplete");
export default setShipComplete;
